import _ from 'lodash';
import Address from './Address';

function VehicleIncident(claim, ClaimExtension, vehicleIncident) {
    Object.defineProperty(this, 'claim', {
        enumerable: false,
        value: claim
    });
    Object.defineProperty(this, 'ClaimExtension', {
        enumerable: false,
        value: ClaimExtension
    });
    if (vehicleIncident) {
        _.extend(this, vehicleIncident);
        this.depotsAvailable_Ext = claim.depotsAvailable_Ext;
        this.hasDepots_Ext = claim.hasDepots_Ext;
    } else {
        this.driver = null;
        this.vehicleLocation_Ext = new Address();
        this.vehicle = null;
        this.passengers = [];
        this.damagePoints_Ext = [];
        this.vehicleLocationPhone_Ext = null;
        this.depotsAvailable_Ext = claim.depotsAvailable_Ext;
        this.hasDepots_Ext = claim.hasDepots_Ext;
    }

    this.getVehicleType = (categoryCode) => {
        const carTypes = ['priv_car', 'coach_minibus', 'trade_plates'];
        const vanTypes = ['light_comm'];
        const isinCartype =_.some(carTypes, (code) => {
            return code === categoryCode;
        });
        const isinVantype = _.some(vanTypes, (code) => {
            return code === categoryCode;
        });
        if (isinCartype) {
            return 'C';
        }
        if (isinVantype) {
            return 'V';
        }
        return 'N';
    };

    this.isVan = () => {
        return this.getVehicleType() === 'V';
    };

    this.isCar = () => {
        return this.getVehicleType() === 'C';
    };
    this.isprivateCar = () =>{
        return 'priv_car' === this.category_Ext;
    }
}
VehicleIncident.prototype.availableVehicles = function (ClaimExtension, vehicle) {
    return ClaimExtension.availableVehicles(vehicle);
};
VehicleIncident.prototype.availableDrivers = function (ClaimExtension, driver) {
    return ClaimExtension.availableDrivers(driver || this.driver);
};
VehicleIncident.prototype.addPassenger = function (passenger, claim) {
    let newPassenger;
    if (!passenger) {
        newPassenger = claim.createContact();
        newPassenger.injured_Ext = false;
        newPassenger.injuryDescription_Ext = '';
        newPassenger.prefix=null;
    } else {
        newPassenger = passenger;
    }
    this.passengers.unshift(newPassenger);
};
VehicleIncident.prototype.setNewDriver = function (claim) {
    this.driver = claim.createContact();
};

VehicleIncident.prototype.removeDriver = function (claim,driver) {
    claim.removeTempContact(driver);
};

VehicleIncident.prototype.setNewVehicle = function (claim) {
    this.vehicle = claim.lobs.personalAuto.createVehicle();
};
VehicleIncident.prototype.removePassenger = function (p) {
    const idx = this.passengers.indexOf(p);
    this.passengers.splice(idx, 1);
};
VehicleIncident.prototype.getAvailablePassengers = function (ClaimExtension) {
    if (this.vehicleLossParty_Ext === 'insured') {
        return ClaimExtension.availablePassengers();
    }
    return [];

};

VehicleIncident.prototype.createVehicleDamagePointExt = function () {
    const vdp = new VehicleDamagePointExt();
    this.damagePoints_Ext.push(vdp);
    return vdp;
};

VehicleIncident.prototype.removeVehicleDamagePointExt = function (damagePoint) {
    const idx = this.damagePoints_Ext.indexOf(damagePoint);
    if (idx >= 0) {
        this.damagePoints_Ext.splice(idx, 1);
    }
};

VehicleIncident.prototype.maybeAddDefaultDamagePointsForGlass = function () {
    const vehicleLossCauseCode = this._claim.lossCause;
    const isGlassLossCause = vehicleLossCauseCode === '21';
    const isGlassLossCauseForCar = this.isCar() && isGlassLossCause;
    const isGlassLossCauseForVan = this.isVan() && isGlassLossCause;

    if (isGlassLossCauseForCar || isGlassLossCauseForVan) {
        let vehicleDamagePartId = vehicleLossCauseCode;
        if (this.isVan()) {
            const vanPrefix = 'V';
            vehicleDamagePartId = vanPrefix.concat(vehicleLossCauseCode);
        }
        this._updateDamagedPoints(vehicleDamagePartId);
    }
};

VehicleIncident.prototype._updateDamagedPoints = function (id) {
    const damagePoint = this.createVehicleDamagePointExt();
    damagePoint.isDamaged = true;
    damagePoint.damageSeverity = 'minor';
    damagePoint.damagePoint = id;
};

VehicleIncident.prototype.isOtherIncidentInsuredType_Ext = function () {
    function isCurrent(element) {
        if (element.tempID && this.tempID) {
            return !(element.tempID === this.tempID);
        } else if (element.publicID && this.publicID) {
            return !(element.publicID === this.publicID);
        }
        return true;
    }

    function isInsured(el) {
        return el.vehicleLossParty_Ext === 'insured';
    }

    return this.ClaimExtension.vehicleIncidents.filter(isCurrent, this).some(isInsured);
};

VehicleIncident.prototype.isMultipleInsuredNotApplicable = function () {
    
    function isCurrent(element) {
        if (element.tempID && this.tempID) {
            return !(element.tempID === this.tempID);
        } else if (element.publicID && this.publicID) {
            return !(element.publicID === this.publicID);
        }
        return true;
    }

    function isInsured(el) {
        return el.vehicleLossParty_Ext === 'insured';
    }
    
    return this.ClaimExtension.vehicleIncidents.filter(isCurrent, this).some(isInsured) && 
            (!this.ClaimExtension.vehicleIncidents.filter(el => 
                    el.vehicleLossParty_Ext === 'insured')[0].towingTrailerInd_Ext) &&
            (!(this.claim.policy.policyNumber.slice(0,2).toLowerCase() == 'sm' && 
                this.ClaimExtension.vehicleIncidents.filter(el => 
                    el.vehicleLossParty_Ext === 'insured')[0].category_Ext == 'transp_vehicle'));
    
};
export default VehicleIncident;
